module.exports = __webpack_public_path__ + "static/media/undraw_projections.f731b074.svg";